<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          rows: 'minmax(73px, auto) 1fr',
          gap: '0 6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 3, x: 1, width: 12 },
          { size: 4, x: 1, width: 7 },
        ]"
      >
        <component
          :is="item.component"
          v-for="item in cms.intro"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :class="`${name}__intro`"
        />
      </grid-item>
    </grid>
    <grid
      v-if="hasContent"
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          rows: 'minmax(73px, auto) 1fr',
          gap: '0 6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
          { size: 4, x: 1, width: 7 },
        ]"
      >
        <SlideInView
          direction="up"
          slide-distance="100%"
          :threshold="0.1"
          :repeat="false"
          :duration="1"
        >
          <component
            :is="item.component"
            v-for="item in cms.content_left"
            :key="item._uid"
            v-editable="item"
            :cms="item"
            :class="`${name}__content-left`"
          />
        </SlideInView>
      </grid-item>
      <grid-item
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 12 },
          { size: 4, x: 9, width: 7 },
        ]"
      >
        <SlideInView
          direction="up"
          slide-distance="100%"
          :threshold="0.1"
          :repeat="false"
          :duration="1"
        >
          <component
            :is="item.component"
            v-for="item in cms.content_middle"
            :key="item._uid"
            v-editable="item"
            :cms="item"
            :class="`${name}__content-middle`"
          />
        </SlideInView>
      </grid-item>
      <grid-item
        :html-tag="`nav`"
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 13, width: 12 },
          { size: 4, x: 17, width: 7 },
        ]"
      >
        <SlideInView
          direction="up"
          slide-distance="100%"
          :threshold="0.5"
          :repeat="false"
          :duration="1"
        >
          <component
            :is="item.component"
            v-for="item in cms.content_right"
            :key="item._uid"
            v-editable="item"
            :cms="item"
            :class="`${name}__content-right`"
          />
        </SlideInView>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import data from '~/components/organisms/o-x3-column-text/o-x3-column-text.data'
import Colors from '~/mixins/colors'
export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-x3-column-text',
    }
  },

  computed: {
    hasContent() {
      return (
        (this.cms.content_left || []).length > 0 ||
        (this.cms.content_middle || []).length > 0 ||
        (this.cms.content_right || []).length > 0
      )
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#000000',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#FFFFFF'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
        '--text-align': this.cms.text_align || 'center',
      }
    },
  },
}
</script>

<style lang="scss">
.o-x3-column-text {
  text-align: var(--text-align);

  h1 {
    margin: 0;
    margin-bottom: 20px;
  }

  h2,
  h4 {
    font-family: 'NHaasGroteskTXProRegular', 'Helvetica Neue', Arial, sans-serif !important;
    font-size: 40px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 150% !important; /* 60px */
    margin-bottom: 30px !important;
  }

  p {
    font-family: 'NHaasGroteskTXProRegular', 'Helvetica Neue', Arial, sans-serif !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 150% !important; /* 24px */
  }

  .a-eyebrow {
    margin-bottom: 10px;
  }

  li {
    margin-bottom: 0 !important;
    list-style-type: disc !important;
    padding-left: 0 !important;
  }

  li::before {
    display: none !important;
  }
}
</style>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-x3-column-text {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: var(--spacing-top) 0 var(--spacing-bottom);

  ::v-deep .a-cta {
    display: inline-block;
    margin-right: 20px;
    margin-top: 30px;
  }

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  &__grid-item {
    margin-bottom: 50px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  &__content-left,
  &__content-middle,
  &__content-right {
    ::v-deep .a-heading {
      @include font-family($headings-font-family, 600);
      @include font-size(16, 28px);

      margin: 0;
      letter-spacing: 1px;
    }

    ::v-deep .a-copy__text p:last-child {
      margin-bottom: 0;
    }

    ::v-deep .a-copy:last-child p {
      margin-bottom: 0;
    }
  }
}

@include media-breakpoint-up(xl) {
  .o-x3-column-text {
    &__grid-item {
      margin-bottom: initial;
    }
  }
}
</style>
